import React from 'react'
import {observer} from 'mobx-react'
import {pdfjs} from 'react-pdf';
import Tooltip from '@mui/material/Tooltip';
import ConditionalComponent from "../../../Shared/ConditionalComponent";
import Utility from "../../../../Utility";
import PropTypes from "prop-types";
import {useStores} from "../../../../Hooks";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const MediaThumbnail = observer(props => {
    const {procedureStore} = useStores();
    const {isPreview, index, media, inSidebar} = props;

    function setAsCurrent() {
        if (!isPreview) {
            procedureStore.setCurrentMedia(index);
        } else {
            procedureStore.setCurrentPreviewedMedia(index);
        }
    }

    return (
        <div className={`media-thumbnail${inSidebar ? " in-sidebar" : " out-of-sidebar"}`}
             onClick={inSidebar ? null : setAsCurrent}>
            {Utility.renderFileThumbnail(media)}
            <ConditionalComponent if={!inSidebar}>
                <Tooltip
                    className="thumbnail-filename-container"
                    title={media.FileName}
                    placement="top"
                    enterDelay={800}
                >
                    <div className="thumbnail-filename-background"/>
                </Tooltip>
            </ConditionalComponent>
        </div>
    )
});

MediaThumbnail.propTypes = {
    isPreview: PropTypes.bool.isRequired
}
export default MediaThumbnail
